import Component from "./HomepageFeatureCard";
export default Component;
